<template>
  <div class="goodList">
    <el-row :gutter="20"
            v-show="goodList.length">
      <el-col :span="6"
              v-for="item in goodList"
              :key="item.spuId">
        <div class="good-item">
          <img :src="item.skuPicUrl"
               class="cursor-pointer"
               v-if="item.skuPicUrl"
               alt=""
               width="260px"
               height="250px"
               @click="goDetail(item)">
          <img src="~@/assets/img/bitmap.png"
               class="cursor-pointer"
               v-else
               alt=""
               width="260px"
               height="250px"
               @click="goDetail(item)">
          <!-- <div class="price price_text"
               v-show="item.commodityType && item.commodityType.indexOf('非标') > -1">待询价</div> -->
               <!--  v-show="item.commodityType && item.commodityType.indexOf('非标') === -1" -->
          <good-price :price="Number(item.channelPrice) || 0"></good-price>
          <div class="multi_line_overflow good-spu-name line-break">{{item.title}}</div>
          <div class="spu-code">{{$t('product.supplyCommodityCode')}}：{{item.spuCode}}</div>
        </div>
      </el-col>
    </el-row>
    <el-pagination :current-page="page"
                   :page-size="limit"
                   :total="total"
                   v-show="total"
                   class="s2b_page"
                   style="text-align: center;"
                   layout="total, prev, pager, next, jumper"
                   @size-change="pageSizeChangeHandle"
                   @current-change="getDataList">
    </el-pagination>
  </div>
</template>
<script>
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'
export default {
  data () {
    return {}
  },
  props: {
    goodList: {
      type: Array,
      default: () => {
        return []
      }
    },
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 12
    }
  },
  components: {
    GoodPrice
  },
  methods: {
    pageSizeChangeHandle (val) {
    },
    // 跳转页
    getDataList (val) {
      this.$emit('refushDataList', val)
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`punchout-goods-detail?spuId=${goods.spuId}&skuId=`)
    }
  }
}
</script>
<style lang='scss' scoped>
.goodList {
  background: #fff;
  .good-item {
    margin-top: 3px;
    background: #fff;
    height: 380px;
    padding: 20px 10px;
    &:hover {
      -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
      -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
    }
    .price_text {
      font-size: 20px;
    }
    /deep/ .price {
      margin-top: 10px;
      color: #e64c3a;
      font-weight: bold;
      .price-int {
        font-size: 20px;
      }
      .price-point {
        font-size: 10px;
      }
    }
    .good-spu-name {
      height: 34px;
      font-size: 12px;
      font-weight: 400;
      color: #333333;
      line-height: 17px;
    }
    .spu-code {
      margin-top: 8px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 17px;
    }
    img{
      object-fit: contain;
    }
  }
}
</style>
